import { TabSchedule } from './tab-schedule';

export { TabSchedule };
